import { render, staticRenderFns } from "./TaxViewGlobal.vue?vue&type=template&id=c3027fb0"
import script from "./TaxViewGlobal.vue?vue&type=script&lang=js"
export * from "./TaxViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports